<template>
    <div class="flyers-container">
        <ClassicBreadCrumb :title="$t('flyers.title')" />
        <div class="flyer-title">
            <h1>{{ $t("flyers.title") }}</h1>
        </div>
        <div class="flyer">
            <div class="flyer-import">
                <h2>{{ $t("flyers.import_file") }}</h2>
                <div class="flyer-drop">
                    <div class="flyer-wrapper" @dragover="preventDefault" @dragleave="preventDefault" @drop="fileDroping">
                        <input
                            ref="file-selection"
                            id="file-selection"
                            type="file"
                            @change="onFileChanged"
                            accept="application/pdf"
                            capture
                        />
                        <label for="file-selection" class="flyer-drop-label">
                            <img :src="require('@/assets/images/icons/download.svg')" alt="Download"/>
                            <div class="file-selection-text">{{ $t("flyers.readme_first") }} <span @click="openImportDialog"> {{ $t("flyers.readme_second") }}  </span> {{ $t("flyers.readme_last") }}  </div>
                            <div class="file-selection-text">{{ $t("flyers.import_requirement_type") }}</div>
                        </label>
                    </div>
                    <div class="error" v-if="typeError=='FILES'">
                        {{ $t("flyers.error_too_many_files") }}
                    </div>
                    <div class="error" v-if="typeError=='TYPE'">
                        {{ $t("flyers.error_file_not_supported") }}
                    </div>
                    <div class="error" v-if="typeError=='SIZE'">
                        {{ $t("flyers.error_exceeded_file_size") }}
                    </div>
                    <div class="error" v-if="error">
                        {{ errorMessage }}
                    </div>
                    <div class="summary" v-if="!error && isFile && typeError==''">
                        <div class="card-import">
                            <div class="infos">
                                <img :src="require('@/assets/images/icons/icon-pdf.svg')" alt="PDF"/>
                                <div class="header">
                                    <p class="file-name">{{ getTextOverflow(files[0].name) }}</p>
                                    <p class="file-properties" v-if="templateId == '' && success && startDownload && !downloading">PDF - {{ $t('flyers.in_progress') }}</p>
                                    <p class="file-properties" v-if=" templateId == '' && success && startDownload && downloading">PDF - {{convertSize(downloadingProgress.loaded)}} / {{convertSize(downloadingProgress.total)}} </p>
                                    <p class="file-properties" v-if="!startDownload && !downloading" >PDF - {{ size }}</p>
                                </div>
                                <div
                                    class="cross-wrapper"
                                    @click="removeFile"
                                >
                                    <i class="fa fa-times"></i>
                                </div>
                            </div>
                            <ProgressBar v-if="startUpload && !success" v-model="progress"/>
                            <div class="description" v-if="success">
                                <svg class="valid-loading" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2" stroke="#13375A" stroke-width="3" stroke-linecap="round"/>
                                </svg>
                                <div class="description-success">
                                    <p class="success">{{ $t('flyers.success') }}</p>
                                    <p class="next">{{ $t('flyers.processing_download') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flyer-divider">
                <div class="divider"></div>
                <p>{{ $t('flyers.divider') }}</p>
                <div class="divider"></div>
            </div>
            <div class="flyer-templates">
                <h2>
                    {{ $t("flyers.templates", {
                            count: templates.length
                        })
                    }}
                </h2>
                <div :class="['templates-list', startUpload ? 'disabled': '']" v-if="templates.length > 0">
                    <div class="template-card" v-for="template in templates" :key="template.id">
                        <img :src="require('@/assets/images/icons/icon-pdf.svg')" alt="PDF"/>
                        <div class="header">
                            <p>{{ getTextOverflow(template.title) }}</p>
                            <p class="file-properties" v-if="templateId == template.id && startDownload && !downloading">PDF - {{ $t('flyers.in_progress') }}</p>
                            <p class="file-properties" v-if="templateId == template.id && startDownload && downloading">PDF - {{convertSize(downloadingProgress.loaded)}} / {{convertSize(downloadingProgress.total)}} </p>
                            <p class="file-properties" v-if=" !startDownload && !downloading">PDF - {{ convertSize(template.file_size) }}</p>
                            <div class="description" v-if="templateId == template.id && startDownload">
                                <div class="description-success">
                                    <p class="next">{{ $t('flyers.processing_download') }}</p>
                                </div>
                            </div>
                        </div>
                        <BasicButton
                            color="orange"
                            @click="downloadFlyer(template.id)"
                            :disabled="startDownload"
                            :loading="startDownload && templateId == template.id"
                            ><span v-if="templateId != template.id">
                                {{ $t("flyers.download") }}
                            </span>
                        </BasicButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicBreadCrumb from "@/components/entities/ClassicBreadCrumb.vue"
import ProgressBar from "@/components/basic/ProgressBar.vue"
import BasicButton from "@/components/basic/BasicButton.vue"
import {
    getStairwellById
} from "@/services/intratone/stairwell"
import { getTemplates, getFlyers } from "@/services/intratone/flyers";

export default {
    name: 'StairwellFlyer',
    components: {
        ClassicBreadCrumb,
        ProgressBar,
        BasicButton
    },
    data(){
        return {
            files: [],
            startUpload: false,
            downloading: false,
            downloadingProgress: null,
            typeError: '',
            error: false,
            errorMessage : '',
            startDownload: false,
            residenceId: null,
            success: false,
            progress: 10,
            templates : [],
            templateId: '',
            widthSreen: 0
        }
    },
    async created(){
        if (this.$route.params.type === 'residence') {
            this.residenceId = this.$route.params.id
        }else {
            await getStairwellById(this.$route.params.id).
            then((response) => {
                if (response.state === "error") {
                    if (response.code === "API_RESTRICTED") {
                        this.$router.push({
                            path: "/error/401",
                        })
                    } else {
                        this.$router.push({
                            path: "/error/404",
                        })
                    }
                }
                this.residenceId = response.data.idres
            })
        }
        await getTemplates({country: this.$i18n.locale}).then((response) => {
            if(response.data.list){
                this.templates = response.data.list
            }
        })
    },
    mounted() {
        this.widthSreen = document.documentElement.clientWidth
        window.addEventListener("resize", ()=>{
            this.widthSreen = document.documentElement.clientWidth
        });
    },
    beforeUnmount() {
        window.removeEventListener("resize", ()=>{
            this.widthSreen = document.documentElement.clientWidth
        });
    },
    computed:{
        isFile(){
            return this.files instanceof FileList
        },
        size(){
            if (this.files && this.files.length>0) {
                return this.convertSize(this.files[0].size)
            }
            return 0
        }
    },
    watch: {
        files() {
            this.templateId = ''
            this.guessError()
            this.progress = 0
            if (!this.error && this.typeError === '' && this.isFile) {
                this.downloadFlyer()
            }
        }
    },
    methods: {
        onFileChanged(e) {
            if (e.target.files || e.dataTransfer.files) {
                this.files = e.target.files || e.dataTransfer.files
            }
        },
        fileDroping(e) {
            e.preventDefault();
            this.files = e.dataTransfer.files
            
        },
        removeFile(){
            this.files = []
        },
        preventDefault(e) {
            e.preventDefault();
        },
        convertSize(value) {
            if (!isNaN(value) && value !== 0) {
                if(value.toString().length > 6){
                    return `${(value / 1000000).toFixed(2)}Mo`
                }else if(value.toString().length > 3) {
                    return `${(value / 1000).toFixed(2)}Ko`
                }
                return `${value}O`
            }
            return `${value}Mo`
        },
        guessError() {
            this.typeError = ''
            this.error = false
            this.errorMessage = ''
            this.success = false
            if (this.files.length > 0) {
                if (this.files.length > 1) {
                    this.typeError = 'FILES'
                }else if(this.files[0].type != 'application/pdf') {
                    this.typeError = 'TYPE'
                } else if(this.files[0].size > 4000000) {
                    this.typeError = 'SIZE'
                }
            }

        },
        openImportDialog(){
            this.$refs['file-selection'].click()
        },
        getTextOverflow(name){
            if (this.widthSreen >= 835) {
                if(name.length > 51) {
                    return `${name.substring(0, 51)}...`
                }
            }else{
                if (name.length > (this.widthSreen * 51 / 505)) {
                    return `${name.substring(0, (this.widthSreen * 51 / 505))}...`;
                }
            }
            return name;
        },
        getFileName(contentDisposition){
            return contentDisposition.split('filename=')[1].split(';')[0]
        },
        async downloadFlyer(templateId = 0) {
            this.error = false
            this.startDownload = true
            let formData = new FormData();
            this.downloadingProgress = {loaded: 0, total: '?'}
            let config = {
                responseType: 'blob',
                onDownloadProgress: progressEvent => {
                    let total = progressEvent.target.getResponseHeader('x-content-lenght') ? progressEvent.target.getResponseHeader('x-content-lenght') : progressEvent.total 
                    this.downloadingProgress = {loaded: progressEvent.loaded, total: total}
                    this.downloading = true
                }
            }
            if (templateId === 0) {
                formData.append('template', this.files[0])
                this.startUpload = true
                config = {
                    ...config,
                    onUploadProgress: progressEvent => {
                        this.progress = (progressEvent.loaded / progressEvent.total) * 100
                        if(this.progress === 100){
                            this.success = true
                        }
                    }
                }
            }else{
                this.templateId = templateId
                formData.append('template_id', templateId)
                let source = window.location.pathname.replaceAll('/', '').split('-')
                if (source.length > 1) {
                    formData.append('source', source[0])
                }
                
            }
            if (this.$route.params.type === 'stairwell') {
                formData.append('cage_id', this.$route.params.id)
            }
            await getFlyers(this.residenceId, formData, config)
            .then(async (response) => {
                if (response instanceof Blob && response.type === "application/json") {
                    this.error = true
                    let errorJson = JSON.parse(await response.text());
                    this.errorMessage = errorJson.message
                    if (!errorJson.message || errorJson.message === '') {
                        this.errorMessage = this.$t('alerts.errors.2019')
                    }
                }else{
                    const blob = new Blob([response.data], {
                        type: "application/pdf",
                    })
                    const url = URL.createObjectURL(blob)

                    const link = document.createElement("a")
                    link.href = url
                    let fileName = 'flyers.pdf'
                    if(response.headers['content-disposition']){
                        fileName = this.getFileName(response.headers['content-disposition'])
                    }
                    link.download = fileName
                    document.body.appendChild(link)

                    link.click()

                    URL.revokeObjectURL(url)
                    document.body.removeChild(link)
                }

            }).catch((error) => {
                this.error = true
                this.errorMessage = this.$t('alerts.errors.2019')
            }).finally(() =>{
                this.startDownload = false
                this.startUpload = false
                this.templateId = ''
                this.success = false
                this.downloading = false
            })
            
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
@import "@/assets/scss/variables/fontSize.scss";

h1,
h2,
p {
    margin: 0;
}

h1 {
    font-family: "Avenir Black";
}
h2 {
    font-family: $font-avenir-medium;
    font-size: 16px;
    font-weight: 500;
}
p{
    font-family: $font-avenir-medium;
    font-weight: 500;
}
.error {
    color: #F00;
}
.flyers-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    height: 100%;
    padding: 20px 80px 40px 80px;
    overflow-x: auto;
    @media all and (max-width: 1024px) {
        padding: 2em 1em;
    }
    h1 {
        font-size: 30px;
    }
    h2 {
        font-size: 16px;
    }

    .flyer-title {
        display: flex;
        flex-direction: column;
        gap: 1em;

        p {
            font-size: $big;
        }
    }
    .flyer {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 30px;
        width: 489px;
        @media all and (max-width: 834px) {
            width: auto;
        }
        .flyer-import {
            display: flex;
            flex-direction: column;
            gap: 20px;
            input[type='file'] {
                position: absolute;
                opacity: 0;      
                overflow: hidden;
                width: 1px;
                height: 1px;
            }
            .flyer-drop {
                .flyer-wrapper {
                    .flyer-drop-label {
                        display: flex;
                        width: 489px;
                        height: 155px;
                        padding: 5px 12px;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border: 2px dashed $blue-neutral;
                        gap: 2px;
                        margin-bottom: 10px;
                        border-radius: 5px;
                        @media all and (max-width: 834px) {
                            width: auto;
                        }
                        .file-selection-text {
                            text-align: center;
                        }
                        img {
                            margin-bottom: 12px;
                        }
                        span {
                            color: $orange-neutral;
                            text-decoration: underline;
                            cursor: pointer;
                            -webkit-user-select: none;
                            -ms-user-select: none;
                            user-select: none;
                        }
                        
                    }
                }
                .summary{
                    display: flex;
                    flex-direction: column;
                    padding: 15px;
                    border-radius: 5px;
                    background-color: $blue-pale;
                    .card-import {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                        .infos {
                            display: flex;
                            align-items: center;
                            align-self: stretch;
                            gap: 10px;
                            .header {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: flex-start;
                                flex: 1 0 0;
                                .file-properties {
                                    color: $blue-neutral;
                                    font-family:  $font-avenir-book;
                                }
                            }
                            .cross-wrapper {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                gap: 0.5em;
                                cursor: pointer;
                            }
                        }
                        .description {
                            display: flex;
                            align-items: flex-start;
                            gap: 5px;
                            margin-left: 40px;
                            .valid-loading {
                                animation: rotation 1s linear infinite;
                            }
                            .description-success {
                                .success {
                                    font-size: 14px;
                                }
                                .next {
                                    font-weight: 350;
                                    font-family:  $font-avenir-book;
                                }
                            }
                            
                        }
                    }
                    
                }
            }
            
        }
        .flyer-divider {
            display: flex;
            gap: 10px;
            justify-content: space-between;
            align-items: center;
            .divider {
                flex-grow: 1;
                border: solid 1px $blue-neutral;
                height: 0px;
            }
        }
        .flyer-templates {
            display: flex;
            flex-direction: column;
            gap: 20px;
            .templates-list {
                display: grid;
                grid-auto-flow: column;
                gap: 15px 0;
                .template-card {
                    display: flex;
                    padding: 15px;
                    gap: 10px;
                    background-color: $blue-pale;
                    border-radius: 5px;
                    align-self: stretch;
                    grid-column: 1 / 2;
                    align-items: center;
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;
                        flex: 1 0 0;
                        min-width: 290px;
                        @media all and (max-width: 834px) {
                            min-width: auto;
                        }
                        .file-properties {
                            color: $blue-neutral;
                            font-family:  $font-avenir-book;
                        }
                        .description {
                            .description-success {
                                .next {
                                    font-family:  $font-avenir-book;
                                }
                            }
                            
                        }
                    }
                    .btn-grey{
                        max-height: 40px;
                    }
                }
                &.disabled {
                    color: $grey-slate;
                    .template-card {
                        background-color: $grey-residence-neutral;
                        img {
                            filter: grayscale(1);
                        }
                        .btn-grey {
                            background-color: $grey-slate;
                        }
                    }
                }
            }
        }
    }
    
}
@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
} 
</style>